module.exports = __webpack_public_path__ + "static/img/11.2993e2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/11.png
// module id = 0K3r
// module chunks = 0